// src/app/directives/infinite-scroll.directive.ts

import {
  Directive,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  Input,
} from '@angular/core';

@Directive({
  selector: '[appInfiniteScroll]',
})
export class InfiniteScrollDirective {
  @Input() isLoading: boolean = false;
  @Input() classInput: string;
  @Output() scrolled = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    if (this.isLoading) {
      return;
    }

    const container = this.el.nativeElement as HTMLElement;
    const lastItem = container.querySelector(`.${this.classInput}:last-child`);

    if (!lastItem) {
      return;
    }

    const lastItemPosition = lastItem.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const threshold = 150;

    if (lastItemPosition.bottom <= windowHeight + threshold) {
      console.log(
        '%cDirectiva: ¡Condición cumplida! Emitiendo evento...',
        'color: orange;'
      );
      this.scrolled.emit();
    }
  }
}
